import React, { useCallback } from 'react'
import { hooks } from '@front/volcanion'
import { usePhoneCall } from '@abra/hooks/ivr'
import moment from 'moment'
const withContainer = Component => (props) => {
  const { job_id, conflicts } = props
  const onPhoneCall = usePhoneCall()
  const EXTERNAL_PHONE_SERVICE = hooks.useRelayConstant('EXTERNAL_PHONE_SERVICE')
  const [order_id] = hooks.useModel('job', [job_id], { single: true, populate: ['first_step'], mutator: 'first_step.order' })
  const [order] = hooks.useModel('order', [order_id], { single: true, populate: ['info'] })
  const [user_id] = hooks.useFieldValues(['user_id'])
  const [user] = hooks.useModel('user', [user_id], { single: true, populate: ['auth'], })
  const canCallDriver = !!user && !!EXTERNAL_PHONE_SERVICE
  const callDriver = useCallback(() => onPhoneCall(user?.auth?.gsm), [onPhoneCall, user?.auth?.gsm])
  const main_source_time = moment(order?.requestedAt).format('HH:mm')
  const main_destination_time = moment(order?.info?.dest_datetime).format('HH:mm')
  const mergedProps = {
    order_id,
    user_id,
    canCallDriver,
    callDriver,
    main_source_time,
    main_destination_time,
    conflicts
  }

  return <Component {...mergedProps} />
}

export default withContainer
